import React, { useEffect } from 'react'
import './style.css'
import { Col, Container, Row } from 'react-bootstrap'
import Navigation from '../../../components/navigation/Navigation'
import Banner from '../../../components/banner/banner'
import MultiListCard from './multi-list-card/MultiListCard'
import Footer from '../../../components/footer/Footer';
import { APIINTEGRATION } from '../../../assets/images'
import SEO from '../../../components/seo/SEO'



const ProductDevelopment = () => {
    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])



  return (
    <>
    <SEO
      title="Product Development"
      description="Triumphal's product development services take ideas from MVP to full-scale product engineering, with startup advisory and independent validation along the way."
      path="/services/product-development"
      keywords="product development, MVP, product engineering, startup advisory"
    />
    <Navigation />
    <Banner title="Product Development" bg={APIINTEGRATION} />

    <section className='api_intergration_section'>
        
        <Container className='mt-75 mb-75'>
            <div>
            <Row>
                <Col lg={11}>
                <div className='api_intergration_section_title'>

                    <h3>
                    From MVP to scale cloud-native products and SaaS platforms built fast, secure, and maintainable.
                    </h3>

                </div>
                
                
                </Col>

            </Row>

            </div>
            <div className='api_intergration_section_img'>
                {/* <Row>
                    <Col>
                    <div className='text-center'>
                    <img className='img-fluid' src={APISERVICE} alt="imae" />
                    </div>

                  
                    
                    
                    </Col>
                </Row> */}




            </div>

            <div className='api_intergration_cards'>
                <MultiListCard  />
            </div>
          
        </Container>

    </section>

    <Footer />
        
    </>
  )
}

export default ProductDevelopment